import React from 'react';
import { buildGoogleMapsUrl } from '../../utils/googleMaps';

export const AddressLink = ({ address, postcode, city, state, country, testId, className = '' }) => {
  const href = buildGoogleMapsUrl({ address, postcode, city, state, country });
  const displayAddress = String(address ?? '').trim();

  if (!href) {
    return <span data-testid={testId} className={`whitespace-normal [overflow-wrap:anywhere] ${className}`}>{displayAddress || '—'}</span>;
  }

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      title="Open in Google Maps"
      aria-label={`Open ${displayAddress} in Google Maps (new tab)`}
      data-testid={testId}
      onClick={(event) => event.stopPropagation()}
      onKeyDown={(event) => event.stopPropagation()}
      className={`inline-flex max-w-full min-w-0 items-start gap-1 align-top text-teal-700 underline decoration-dotted underline-offset-2 hover:text-teal-900 hover:decoration-solid focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-600 transition-colors ${className}`}
    >
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="mt-0.5 shrink-0" aria-hidden="true">
        <path d="M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 1 1 16 0Z" />
        <circle cx="12" cy="10" r="3" />
      </svg>
      <span className="min-w-0 whitespace-normal [overflow-wrap:anywhere]">{displayAddress}</span>
    </a>
  );
};